/* eslint-disable no-useless-escape */
import * as yup from 'yup';

const URL_REGEXP = /^(((https?|ftp):)?\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i

export const contactsFormSchema = yup.object().shape({
  website: yup.string().matches(URL_REGEXP, 'Website must be a valid URL').required('Please enter website url'),
  company: yup.string().required('Please enter company/your name'),
  address: yup.string().required('Please enter address'),
  email: yup.string().email('Email is not valid').required('Please enter an email'),
  phone: yup.string(),
})

export const informationFormSchema = yup.object().shape({
  collectInfo: yup.array().ensure().min(1, 'At least one should be checked').required('At least one should be checked'),
  wayCollect: yup.array().ensure().min(1, 'At least one should be checked').required('At least one should be checked'),
  collectDays: yup.number().typeError('Please enter number of days').positive(' Number of days must be positive number')
    .nullable().required('Please enter number of days'),
})

export const usageFormSchema = yup.object().shape({
  useCollectInfo: yup.array().ensure(),
  shareCollectInfo: yup.array().ensure(),
  isUseThirdPartyService: yup.bool(),
  thirdPartyService: yup.array().ensure().when("isUseThirdPartyService", {
      is: true,
      then: yup.array().ensure().min(1, 'At least one should be checked').required('At least one should be checked'),
    })
})

export const extrasFormSchema = yup.object().shape({
  cookiesCategories: yup.array().ensure().min(1, 'At least one should be checked').required('At least one should be checked'),
  privacyOfficer: yup.string().required('At least one should be checked'),
  cookieId: yup.string().test('lenCustom', 'Cookie ID must be exactly 32 characters', (val) => {
    const trimVal = val.toString().trim()
    return trimVal.length === 0 || trimVal.length === 32;
  }),
  officerName: yup.string().when('privacyOfficer', (privacyOfficer, schema) => (
    privacyOfficer !== 'No person, just use company contacts' ? schema.required('Please enter officer name') : schema
  )),
  officerEmail: yup.string().email('Email is not valid').when('privacyOfficer', (privacyOfficer, schema) => (
    privacyOfficer !== 'No person, just use company contacts' ? schema.required('Please enter officer email') : schema
  )),
  officerPhone: yup.string(),
  effectiveDate: yup.string().nullable().required('Please enter an effective date'),
})